const TOKEN_KEY = 'token'
const NAME_KEY = 'username'
const STATE_KEY = 'userstate'
const FIELD_KEY = 'fieldname'
const localStorage = window.localStorage

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY)
}

export const setToken = token => {
  localStorage.setItem(TOKEN_KEY, token)
}

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY)
}

export const getName = () => {
  return localStorage.getItem(NAME_KEY)
}
export const setName = name => {
  localStorage.setItem(NAME_KEY, name)
}
export const removeName = () => {
  localStorage.removeItem(NAME_KEY)
}

export const getState = () => {
  return localStorage.getItem(STATE_KEY)
}
export const setState = state => {
  localStorage.setItem(STATE_KEY, state)
}
export const removeState = () => {
  localStorage.removeItem(STATE_KEY)
}

export const getFieldname = () => {
  return localStorage.getItem(FIELD_KEY)
}
export const setFieldname = fieldname => {
  localStorage.setItem(FIELD_KEY, fieldname)
}
export const removeFieldname = () => {
  localStorage.removeItem(FIELD_KEY)
}
// export const getBreadcrumb = () => {
//   let currentCity=localStorage.getItem(Bread_KEY);
//   if(currentCity){
//     let item=JSON.parse(currentCity);
//     return item
//   }
// }
// export const setBreadcrumb = data => {
//     let selectCity=JSON.stringify(data);//将json对象转化成字符串
//     localStorage.setItem(Bread_KEY,selectCity);//把选择的数据存储在localstorage中
// }
